import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let { DANGER_ERROR_COLOR, ERROR_BACKGROUND_COLOR_DANGER } = constants;

let styles = {
  text: {
    textAlign: 'center',
    width: '40%',
    fontSize: '14px',
    display: 'flex',
    borderRadius: '0.25rem',
    fontWeight: 600,
    background: ERROR_BACKGROUND_COLOR_DANGER,
    position: 'absolute',
    left: '25%',
    top: 23,
    padding: '6px 10px 6px'
  },
  p: {
    margin: '4px 0',
    color: DANGER_ERROR_COLOR
  },
  cross: {
    color: DANGER_ERROR_COLOR,
    marginLeft: 5,
    cursor: 'pointer',
    position: 'absolute',
    right: '2%',
    top: '26%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/errorBanner/error.styles.js